import CommonService from '@/_core/service/commonService';
import store from '@/store';
import routeMixin from '@/_core/mixins/routeMixin.js';

const logoutMixin = {
  mixins: [routeMixin],
  data() {
    return {
      redirectUrl: '',
    };
  },
  async created() {
    if (store.getters['userStore/userData'].isRefreshToken) {
      return;
    }
    let redirectUrl;

    if (store.getters['userStore/userData']?.redirectURL) {
      redirectUrl = store.getters['userStore/userData'].redirectURL;
    } else {
      try {
        redirectUrl = await CommonService.getRedirectURL();
      } catch (e) {
        console.log('error in app logoutMixin.js in redirectUrl', e);
      }
    }
    this.redirectUrl = redirectUrl;
  },
  methods: {
    async logout() {
      const productType = this.getProductType;
      const productCode = this.getProductCode;
      const productTerm = this.getProductTerm;
      const applicationCode = 'fede';
      const customerOnboarding = 'customerOnboarding';
      const timeOutUrl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/' + applicationCode + '/' + productType + '/' + productCode + '/' + productTerm + '/' + customerOnboarding;
      window.location = timeOutUrl;
    },
  },
};

export default logoutMixin;
